const BASE_URI = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_URI : ''

export const version = 2.1;
export const startYear = '20182019'
export const api = `${BASE_URI}/api/v1`
export const syncModal = 'static'

export const SE = 'server_error'